<template>
  <footer class="footer" v-if="!esSelfi">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{ path: '/cajas-online' }"
              >Numier ONLINE</router-link
            >
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ $t("desarrolladoPorNexodoDigitalSL") }}
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      esSelfi: false,
    };
  },

  created() {
    this.checkIsSelfi();
  },

  methods: {
    checkIsSelfi() {
      let vm = this;

      const esSelfiCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("esSelfi="));

      // Verificar si la cookie existe antes de intentar acceder a su valor
      if (esSelfiCookie) {
        vm.esSelfi = esSelfiCookie.split("=")[1];
      } else {
        vm.esSelfi = false;
      }
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/ContentFooter.vue